import { TranslateFn } from 'src/localization/translate'

import { KybFieldError } from './paymentsKyb.validation'

/**
 * Map a validation error code to a user-facing message — but ONLY for
 * *format/invalid* codes (malformed input the user should correct), not the
 * `*_REQUIRED` codes. Required-but-empty fields keep the step's "Next" button
 * disabled without painting a red error on a pristine form, matching the
 * prototype's disabled-Next gating.
 */
export function kybInvalidMessage(
  translate: TranslateFn,
  code: KybFieldError | undefined,
): string | undefined {
  switch (code) {
    case 'DATE_FORMED_INVALID':
    case 'OWNER_DOB_INVALID':
      return translate('Enter a valid date.')
    case 'ACTIVITY_VOLUME_INVALID':
      return translate('Enter a positive whole dollar amount.')
    case 'EIN_INVALID':
      return translate('Enter a valid 9-digit EIN.')
    case 'EMAIL_INVALID':
    case 'OWNER_EMAIL_INVALID':
      return translate('Enter a valid email address.')
    case 'WEBSITE_INVALID':
      return translate('Enter a valid website.')
    case 'PHONE_INVALID':
    case 'OWNER_PHONE_INVALID':
      return translate('Enter a valid phone number, e.g. +15551234567.')
    case 'OWNER_OWNERSHIP_INVALID':
      return translate('Enter a percentage between 25 and 100.')
    case 'OWNER_SSN_INVALID':
      return translate('Enter a valid 9-digit SSN.')
    default:
      return undefined
  }
}
